import { Box, HStack, Text, VStack } from "@chakra-ui/react"
import { CoolDownStatus, Staking } from "container/staking"
import { XState } from "container/xstate"
import React from "react"
import { StakeIcon, UnStakeIcon } from "../../../../component/Icon"
import { PendingProgress } from "../PendingProgess"

const Notice = {
    [CoolDownStatus.init]: "UNSTAKE",
    [CoolDownStatus.onGoing]: "IN COOLDOWN",
    [CoolDownStatus.readyToWithdraw]: "READY TO UNSTAKE",
}

export function Action() {
    const {
        actions: { xStake, xUnStake },
    } = XState.useContainer()

    const { cooldownStatus } = Staking.useContainer()
    const shouldShowLights = cooldownStatus !== CoolDownStatus.init

    return (
        <HStack spacing="80px" pt="50px" align="flex-start" minHeight={130}>
            <VStack>
                <Box
                    transition="all 0.21s"
                    position="relative"
                    top="0px"
                    borderRadius="40px"
                    _hover={{ top: "-2px", bg: "rgba(0,0,0,0.04)" }}
                    _active={{
                        top: "4px",
                    }}
                    as="button"
                    onClick={xStake}
                >
                    <StakeIcon />
                </Box>
                <Text color="#D1D1D1" fontSize="11px" fontWeight="bold" textAlign="center" w="55px">
                    STAKE
                </Text>
            </VStack>
            <VStack w="55px">
                <Box
                    transition="all 0.21s"
                    position="relative"
                    top="0px"
                    borderRadius="40px"
                    _hover={{ top: "-2px", bg: "rgba(0,0,0,0.04)" }}
                    _active={{
                        top: "4px",
                    }}
                    as="button"
                    onClick={xUnStake}
                >
                    <UnStakeIcon />
                </Box>
                <Text color="#D1D1D1" fontSize="11px" fontWeight="bold" w="200px" textAlign="center">
                    {Notice[cooldownStatus]}
                </Text>
                {shouldShowLights && <PendingProgress />}
            </VStack>
        </HStack>
    )
}
